if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      this.giftProduct = document.querySelector('#gift-product').innerHTML;
      if (this.giftProduct) {
        this.giftProduct = JSON.parse(this.giftProduct);
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      this.getGiftProduct();
    }

    async formSubmit() {
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList?.remove('hidden');

      try {
        await window.CartAPI.addFromForm(this.form);
        submitButton.innerHTML = '<span>ADDED TO BAG</span>';
      } catch (error) {
        console.log(error)
      }

      submitButton.classList.remove('loading');
      submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay__spinner')?.classList?.add('hidden');
    }

    getGiftProduct () {
      const variant_id = sessionStorage.getItem("variant_id") ? Number(sessionStorage.getItem("variant_id")) : -1;
      const gift_note = sessionStorage.getItem("gift_note") ? sessionStorage.getItem("gift_note") : "";
      const giftWrappingInput = document.querySelector('[js-gift-wrapping] input');

      if (variant_id && variant_id != -1 && giftWrappingInput.checked) {
        this.addGiftWrapping(variant_id, gift_note);
      } else {
        this.formSubmit();
      }
    }

    addGiftWrapping (id, note) {
      const headers = new Headers({ 'Content-Type': 'application/json' });
      const key = id;
      let updates = {};
      updates[key] = 1;

      let formData = {
          updates: updates,
          attributes: {
            'gift-wrapping': true,
            'gift-note': note,
            'gift-product-id': this.giftProduct.variants[0].id,
          }
      };

      var request = {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(formData)
      };

      fetch('/cart/update.js', request)
      .then((response) => response.json())
      .then((response) => {
        sessionStorage.setItem("variant_id", "");
        sessionStorage.setItem("gift_note", "");

        this.formSubmit();
      })
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
